import { useState } from 'react';
import { toast } from 'sonner';

// Actions
import { sendRequestFeedback } from '@/actions';

// Constants
import { TRAINING_TOAST_MESSAGES } from '@/constants';

// Types
import { RequestFeedbackPayload } from '@/types';

// Utils
import { showErrorToast } from '@/utils';

export const useSendRequestFeedback = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data: RequestFeedbackPayload) => {
    setIsSubmitting(true);

    try {
      const { error } = await sendRequestFeedback(data);

      if (error) {
        showErrorToast(error);

        return;
      }

      toast.success(TRAINING_TOAST_MESSAGES.SEND_REQUEST_FEEDBACK_SUCCESS);
    } catch (error) {
      showErrorToast(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    isSubmitting,
    handleSubmit,
  };
};
